import React from 'react'
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'

import lang from '@/lang'

import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons'
import IconCheck from '@assets/images/icons/check.svg'

import { nextStep, prevStep } from '@/redux/ducks/wizard/config'

const Footer = ({
  onBackButtonClick = null,
  onNextButtonClick,
  onAbortButtonClick,
  disabled,
  hidePrevButton,
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const { step, totalSteps } = useSelector(state => state.wizard.config)

  const prev = () => {
    if (onBackButtonClick) {
      if (onBackButtonClick()) {
        dispatch(prevStep())
      }
    } else {
      dispatch(prevStep())
    }
  }

  const next = () => {
    if (onNextButtonClick) {
      if (onNextButtonClick()) {
        dispatch(nextStep())
      }
    } else {
      dispatch(nextStep())
    }
  }

  return (
    <div className={classes.footer}>
      {step === 0 && onAbortButtonClick && (
        <CancelButton
          className={classes.back}
          onClick={onAbortButtonClick}
          label={lang.onboarding.general.abort}
        />
      )}
      {step > 0 && !hidePrevButton && (
        <CancelButton
          className={classes.back}
          onClick={prev}
          label={lang.onboarding.general.back}
        />
      )}
      <ButtonIconSquare
        className={classes.next}
        disabled={disabled}
        icon={IconCheck}
        label={step < totalSteps ? lang.onboarding.general.next : lang.onboarding.general.finish}
        onClick={next}
      />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  footer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 0,
    zIndex: 20,
    '@media (min-width: 800px)': {
      padding: '0 40px 30px 40px',
      maxWidth: 'unset',
    },
  },
  next: {
    width: '100%',
    '@media (min-width: 800px)': {
      width: 'auto',
      margin: '0 0 0 auto',
    },
    '& .SVGInline': {
      display: 'none',
      '@media (min-width: 800px)': {
        display: 'inherit',
      },
    },
  },
  back: {
    display: 'none',
    '@media (min-width: 800px)': {
      display: 'block',
    },
  },
}))

export default Footer
